import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { DAYS } from "@/lib/adega";

export default function HoursEditor({ value, onChange }) {
  const set = (d, patch) => onChange({ ...value, [d]: { ...value[d], ...patch } });
  return (
    <div className="space-y-2" data-testid="hours-editor">
      {DAYS.map((label, i) => {
        const d = String(i);
        const h = value[d] || { open: false, start: "10:00", end: "22:00" };
        return (
          <div key={d} className="flex items-center gap-2 rounded-lg bg-black/30 border border-white/10 px-3 py-2">
            <Switch checked={h.open} onCheckedChange={(v) => set(d, { open: v })} data-testid={`hours-open-${d}`} />
            <span className="w-16 text-sm font-medium">{label.slice(0, 3)}</span>
            {h.open ? (
              <div className="flex items-center gap-1.5 flex-1 justify-end">
                <Input type="time" value={h.start} onChange={(e) => set(d, { start: e.target.value })} className="h-9 w-[92px] px-2" data-testid={`hours-start-${d}`} />
                <span className="text-muted-foreground text-xs">até</span>
                <Input type="time" value={h.end} onChange={(e) => set(d, { end: e.target.value })} className="h-9 w-[92px] px-2" data-testid={`hours-end-${d}`} />
              </div>
            ) : (
              <span className="flex-1 text-right text-xs text-muted-foreground">Fechado</span>
            )}
          </div>
        );
      })}
      <p className="text-[11px] text-muted-foreground">Se fecha depois da meia-noite, coloque o horário da madrugada (ex: 18:00 até 02:00).</p>
    </div>
  );
}
